/**
 * Returns the first child of `node` it only has one child.
 *
 * @param {Object} node the node to check
 * @returns {*|null}
 */
export default node => (node?.$children && node?.$children.length === 1
  ? node.$children[0]
  : null)
